export const PUBSUB_DEFAULT_HOST = '/gateway/api/pubsub';

export const PUBSUB_PRODUCT_JIRA = 'JIRA';
